import styled from 'styled-components';

import { OldFrameSidebarWidth } from 'styles/constants';

const variantColors = {
  warning: {
    background: 'wfYellow100', // '#FFFAE6',
    border: 'wfYellow', // '#ffcb00',
    shadow: 'wfYellow600', // '#FFE066',
  },
  error: {
    background: 'wfOrange100', // '#FFEFE6',
    border: 'wfOrange', // '#ff4d00',
    shadow: 'wfOrange600', // '#FF9E66',
  },
  info: {
    background: 'wfBlue100', // '#e6ecff',
    border: 'primary', // '#0f2eff',
    shadow: 'wfBlue600', // '#658BFF',
  },
};

// props.type list => Object.keys(variantColors) || ['warning', 'error', 'info']

export const SystemMessageStyled = styled.div`
  position: fixed;
  top: ${props => props.top || '82px'};
  width: fit-content;
  left: calc(
    ${OldFrameSidebarWidth}px + ${props => props.canvasWidth || `100%`} / 2
  );
  transform: translateX(-50%);
  height: auto;
  background-color: ${props =>
    props.theme.color[variantColors[props.type].background]};
  border: 1px solid
    ${props => props.theme.color[variantColors[props.type].border]};
  color: black;
  border-radius: 20px;
  z-index: 1003;
  font-size: ${props => props.theme.font.size.small};
  padding: ${props =>
    `${props.theme.spacing.small} ${props.theme.spacing.default}`};
`;

export const Kbd = styled.kbd`
  display: inline-block;
  border-radius: 4px;
  padding: 0.1em 0.5em;
  margin: 0 0.2em;
  font-family: ${props => props.theme.font.family.primary};
  background-color: ${props =>
    props.theme.color[variantColors[props.type].border]};
  color: ${props => props.theme.color.wfWhite};
`;

export const Anchor = styled.a`
  color: ${props => props.theme.color.primary};
  text-decoration: underline;
`;
